import { useTheme } from "styled-components";
import { IThemeBreakpoints } from "../types/theme";
import _get from "lodash/get";
import { useEffect, useState } from "react";

export const useMediaQuery = (
  device: keyof IThemeBreakpoints,
  defaultValue?: boolean
) => {
  const theme = useTheme();
  const breakpoint = _get(theme, `breakpoints.${device}`);

  const getInitialMatch = () => {
    if (typeof window === "undefined" || !breakpoint) {
      return defaultValue !== undefined ? defaultValue : false;
    }

    return window.matchMedia(`(min-width: ${breakpoint})`).matches;
  };

  const [matches, setMatches] = useState<boolean>(getInitialMatch);

  useEffect(() => {
    if (typeof window === "undefined" || !breakpoint) {
      return;
    }

    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint})`);

    const handleChange = (event: MediaQueryListEvent) => {
      const nextMatches = event.matches;
      setMatches((prev: boolean) =>
        prev === nextMatches ? prev : nextMatches
      );
    };

    setMatches((prev: boolean) =>
      prev === mediaQuery.matches ? prev : mediaQuery.matches
    );

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    } else {
      mediaQuery.addListener(handleChange);
      return () => {
        mediaQuery.removeListener(handleChange);
      };
    }
  }, [breakpoint]);

  return matches;
};
